import * as React from "react";
import { CoinTickersMapped } from "../../../../types/api-results/coin-tickers";
import { SiteContext } from "../../../site-context/site-context";
import { EventCategory } from "../../../utils/analytics";
import Link from "../../ui-library/link/link";
import { Table, TBody } from "../../ui-library/table/table";
import CoinCell from "./coin-cell";
import CoinTickersTableHead from "./coin-tickers-table-head";
import styles from "./coin-tickers-table.styles";
import ExchangeCell from "./exchange-cell";
import { formatCoinTickers } from "./format-coin-tickers";

interface CoinTickersTableProps {
  data: CoinTickersMapped[];
  totalVolume: number;
  tableFor: "coin" | "exchange";
  eventCategory: EventCategory;
}

const CoinTickersTable: React.FC<CoinTickersTableProps> = ({
  data,
  totalVolume,
  tableFor,
  eventCategory,
}) => {
  const {
    currency: [currency],
    usdExchangeRate,
    isMobile,
  } = React.useContext(SiteContext);

  const rowsData = formatCoinTickers({
    data,
    totalVolume,
    usdExchangeRate,
    currency,
  });

  return (
    <div css={styles.root}>
      <Table>
        <CoinTickersTableHead />
        <TBody>
          {rowsData.map((row) => (
            <tr key={row.key}>
              {!isMobile && (
                <td css={[styles.colAlignment[0], styles.rank]}>{row.rank}</td>
              )}
              <td css={[styles.colAlignment[1]]}>
                {tableFor === "coin" ? (
                  <ExchangeCell {...row} eventCategory={eventCategory} />
                ) : (
                  <CoinCell
                    rank={row.rank}
                    {...row.fromCoin}
                    eventCategory={eventCategory}
                  />
                )}
              </td>
              <td css={[styles.colAlignment[2], styles.ticker]}>
                {row.tradeUrl ? (
                  <Link
                    to={row.tradeUrl}
                    target="_blank"
                    analytics={{
                      category: eventCategory,
                      action: "Click - Trading pair url",
                      label: row.pairSymbols,
                    }}
                  >
                    {row.pairSymbols}
                  </Link>
                ) : (
                  row.pairSymbols
                )}
              </td>
              <td css={[styles.colAlignment[3], styles.label]}>{row.price}</td>
              <td css={[styles.colAlignment[4], styles.label]}>{row.volume}</td>
              <td css={[styles.colAlignment[5], styles.label]}>
                {row.volumePercent}
              </td>
            </tr>
          ))}
        </TBody>
      </Table>
    </div>
  );
};

export default CoinTickersTable;
